import React from 'react';
import './TitleBannerSection.css';

export default function TitleBannerSection() {
  return (
    <section className="section title-banner-section" id="title">
      {/* overlay removed */}
      <div className="container title-banner-container">
        <h2 className="tb-heading" aria-label="Enjoy Sweet Justice from GOLDLAW">
          <span className="tb-line tb-line1 is-revealed">Enjoy Sweet Justice</span>
          <span className="tb-line tb-line2">FROM GOLDLAW</span>
        </h2>
      </div>
    </section>
  );
}
